import { surfaceBusyTooltip } from '../../core/surface/surface.busy';

/** What the Detail header draws for its board panel when the panel lends it the title bar. */
export interface DetailPanelControls {
  readonly step: { readonly label: string | null; readonly previousDisabled: boolean; readonly nextDisabled: boolean } | null;
  /** ⤢ tooltip; null hides it. */
  readonly expand: string | null;
  readonly dock: boolean;
  readonly openPage: boolean;
  /** Replaces every control's tooltip while an upload runs; the controls stay live and wait through the leave guard. */
  readonly hold: string | null;
}

export interface DetailPanelControlsInput {
  readonly ownsHeader: boolean;
  readonly canStep: boolean;
  /** Board-owned: on a paged board the arrows stop at the page edge, so index alone cannot decide them. */
  readonly position: { readonly index: number; readonly total: number; readonly canPrevious: boolean; readonly canNext: boolean } | null;
  /** The board's resolved ⤢ / ⤡; the board decides what expanding opens. */
  readonly expand: { readonly tooltip: string | null; readonly canDock: boolean };
  readonly recordPageUrl: string | null;
  /** The mounted page has tracked work in flight. */
  readonly busy: boolean;
}

const NONE: DetailPanelControls = { step: null, expand: null, dock: false, openPage: false, hold: null };

/** A panel that draws its own header already shows these controls; drawing them here too would double them. */
export function resolveDetailPanelControls(input: DetailPanelControlsInput | null): DetailPanelControls {

  if (!input || input.ownsHeader) return NONE;
  const position = input.position;
  return {
    step: input.canStep
      ? { label: position ? `${position.index} of ${position.total}` : null, previousDisabled: !(position?.canPrevious ?? true), nextDisabled: !(position?.canNext ?? true) }
      : null,
    expand: input.expand.tooltip,
    dock: input.expand.canDock,
    openPage: input.recordPageUrl != null,
    hold: surfaceBusyTooltip(input.busy),
  };
}
